import { noteActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [noteActions.showChargeAddendumQuestion]: (state, action) => {
        const { noteId, charges } = action.payload;
        if (!state[noteId]) {
            state[noteId] = {};
        }
        state[noteId].charges = charges;
    },


})


